/**
 * Ключ нормалізації об'єкта в кеші Apollo (InMemoryCache.dataIdFromObject).
 * За замовчуванням — голий `id` без `__typename`: об'єкти різних типів (або одного типу з різних
 * батьків) з однаковим id склеюються в один запис кешу в межах однієї відповіді.
 * Для таких типів нижче — окремі ключі.
 */
export default function dataIdFromObject(object) {
  switch (object.__typename) {
  case 'DepartmentGraph': {
    return `${object.__typename}:${object.id}:${object.name}`
  }
  case 'ApplicationRowGraph': {
    return `${object.__typename}:${object.headerId}:${object.id}`
  }
  case 'ClassificationGraph':
  case 'GrowthbookAdminFeature':
  case 'GrowthbookAdminFeatureRule':
  case 'GrowthbookAdminProject':
  case 'GrowthbookAdminEnvironment': {
    return `${object.__typename}:${object.id}`
  }
  // id оточення фічі ('production'...) унікальний лише в межах фічі — не нормалізуємо,
  // інакше оточення всіх фіч склеюються в одне (стан останньої фічі для всіх)
  case 'GrowthbookAdminFeatureEnvironment': {
    return null
  }
  default: return object.id || object._id // fall back to `id` and `_id` for all other types
  }
}
